var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{attrs:{"data-visible":_vm.visible}},[_vm._t("default"),_c('button',{attrs:{"type":"button","tabindex":!_vm.visible && -1},on:{"click":function($event){$event.preventDefault();return _vm.$emit('close')}}},[_vm._v("OK")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }